"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areValidDims = exports.normaliseItemsDimensionAndWeight = exports.volumetricEstimation = exports.estimatePallets = exports.REPLENISHMENT_PALLET_ESTIMATION_CONSTANT = exports.REPLENISHMENT_MAX_PALLET_VOLUME_IN_CUBIC_INCH = exports.REPLENISHMENT_MAX_PALLET_WEIGHT = void 0;
const lodash_1 = require("lodash");
const UnitConversionUtils_1 = require("./UnitConversionUtils");
const errors_1 = require("@deliverr/errors");
exports.REPLENISHMENT_MAX_PALLET_WEIGHT = 1500;
exports.REPLENISHMENT_MAX_PALLET_VOLUME_IN_CUBIC_INCH = 72 * 48 * 40;
exports.REPLENISHMENT_PALLET_ESTIMATION_CONSTANT = 1.1;
function estimatePallets(items, overridePalletEstimationConstant) {
    const fn = "PalletEstimationUtils.estimatePallets()";
    if (!items || items.length === 0) {
        throw new errors_1.DeliverrError({
            functionName: fn,
            message: "Items not found",
            code: "BAD_REQUEST",
        });
    }
    if (items.length > 1e6) {
        throw new errors_1.DeliverrError({
            functionName: fn,
            message: "Items list is too large, greater than 1000_000",
            code: "BAD_REQUEST",
        });
    }
    throwIfInvalidDims(items, fn);
    const itemsWithNormalisedDimensionAndWeight = normaliseItemsDimensionAndWeight(items);
    return volumetricEstimation(itemsWithNormalisedDimensionAndWeight, overridePalletEstimationConstant !== null && overridePalletEstimationConstant !== void 0 ? overridePalletEstimationConstant : exports.REPLENISHMENT_PALLET_ESTIMATION_CONSTANT);
}
exports.estimatePallets = estimatePallets;
function volumetricEstimation(normalisedItems, estimationConstant) {
    const numberOfItems = (0, lodash_1.sum)(normalisedItems.map((item) => item.qty));
    const lengthAvg = (0, lodash_1.mean)(normalisedItems.map((item) => item.length));
    const widthAvg = (0, lodash_1.mean)(normalisedItems.map((item) => item.width));
    const heightAvg = (0, lodash_1.mean)(normalisedItems.map((item) => item.height));
    const weightAvg = (0, lodash_1.mean)(normalisedItems.map((item) => item.weight));
    return Math.ceil(numberOfItems /
        Math.min(exports.REPLENISHMENT_MAX_PALLET_VOLUME_IN_CUBIC_INCH / (estimationConstant * lengthAvg * widthAvg * heightAvg), exports.REPLENISHMENT_MAX_PALLET_WEIGHT / (estimationConstant * weightAvg)));
}
exports.volumetricEstimation = volumetricEstimation;
function normaliseItemsDimensionAndWeight(items) {
    return items.map((item) => {
        return {
            length: (0, UnitConversionUtils_1.convertLength)(item.length, item.lengthUnit, "in"),
            width: (0, UnitConversionUtils_1.convertLength)(item.width, item.lengthUnit, "in"),
            height: (0, UnitConversionUtils_1.convertLength)(item.height, item.lengthUnit, "in"),
            weight: (0, UnitConversionUtils_1.convertWeight)(item.weight, item.weightUnit, "lb"),
            lengthUnit: "in",
            weightUnit: "lb",
            qty: item.qty,
        };
    });
}
exports.normaliseItemsDimensionAndWeight = normaliseItemsDimensionAndWeight;
function throwIfInvalidDims(items, fn) {
    const index = findInvalidItem(items);
    if (index !== -1) {
        throw new errors_1.DeliverrError({
            functionName: fn,
            message: `Invalid dimension or weight or qty of items`,
            code: "INVALID_DIMS",
        });
    }
}
function findInvalidItem(items) {
    for (let i = 0; i < items.length; i++) {
        if (!(0, exports.areValidDims)(items[i]) ||
            items[i].length * items[i].width * items[i].height > exports.REPLENISHMENT_MAX_PALLET_VOLUME_IN_CUBIC_INCH ||
            items[i].weight > exports.REPLENISHMENT_MAX_PALLET_WEIGHT) {
            return i;
        }
    }
    return -1;
}
const areValidDims = (dims) => {
    return dims && dims.length > 1 && dims.height > 1 && dims.width > 1 && dims.weight > 0;
};
exports.areValidDims = areValidDims;
//# sourceMappingURL=PalletEstimationUtils.js.map